export default "__VITE_ASSET__C5OwgOV___"